module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-21.0cd1c3c7.png";